import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get purchaseReturn
export const getPurchaseReturn = createAsyncThunk(
  "purchaseReturn/getPurchaseReturn",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseReturn({ rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseReturn
export const getAllPurchaseReturn = createAsyncThunk(
  "purchaseReturn/getAllPurchaseReturn",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseReturn();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseReturn/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseReturn/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseReturn/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseReturn({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPurchaseReturnById = createAsyncThunk(
  "purchaseReturn/getPurchaseReturnById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseReturnById(id);

      if (data?.data?.salesOrderMain?.saleDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data?.data?.salesOrderMain?.saleDetails?.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return {
          ...data,
          data: { ...data.data, salesOrderMain: { ...data.data.salesOrderMain, saleDetails: updatedDetails } },
        };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getPurchaseInvoiceDetail = createAsyncThunk(
  "purchaseReturn/getPurchaseInvoiceDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseInvoiceDetail(id);

      if (data?.data.purchaseInvoiceDetail?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.purchaseInvoiceDetail.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, purchaseInvoiceDetail: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getPurchaseReturnAdditionalChargeList = createAsyncThunk(
  "purchaseReturn/getPurchaseReturnAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseReturnAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// create purchaseReturn
export const createPurchaseReturn = createAsyncThunk(
  "purchaseReturn/createPurchaseReturn",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseOrderInvoice,
      branch,
      refundAmount,
      grandTotal,
      vatAmount,
      purchaseOrderReturnDetails,
      purchaseOrderReturnAdditionalChargeCost,
      purchaseOrderReturnMainPartyDetails,
      purchaseOrderReturnMainVehicleDetail,
    } = createData;
    try {
      const body = JSON.stringify({
        branch,
        refundAmount,
        purchaseOrderInvoice,
        grandTotal,
        vatAmount,
        purchaseOrderReturnDetails,
        purchaseOrderReturnAdditionalChargeCost,
        purchaseOrderReturnMainPartyDetails,
        purchaseOrderReturnMainVehicleDetail,
      });

      const { data } = await API.createPurchaseReturn(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePurchaseReturn = createAsyncThunk(
  "purchaseReturn/updatePurchaseReturn",
  async (params, { rejectWithValue }) => {
    const { id, values } = params;
    const {
      purchaseOrderInvoice,
      purchaseReturnNo,
      status,
      branch,
      refundAmount,
      grandTotal,
      vatAmount,
      purchaseOrderReturnDetails,
      purchaseOrderReturnMainPartyDetails,
      purchaseOrderReturnMainVehicleDetail,
    } = values;
    try {
      const body = JSON.stringify({
        purchaseOrderInvoice,
        purchaseReturnNo,
        status,
        branch,
        refundAmount,
        grandTotal,
        vatAmount,
        purchaseOrderReturnDetails,
        purchaseOrderReturnMainPartyDetails,
        purchaseOrderReturnMainVehicleDetail,
      });
      const { data } = await API.updatePurchaseReturn(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const approvePurchaseReturn = createAsyncThunk(
  "purchaseReturn/approvePurchaseReturn",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.approvePurchaseReturn(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const cancelPurchaseReturn = createAsyncThunk(
  "purchaseReturn/cancelPurchaseReturn",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.cancelPurchaseReturn(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseReturn/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
